import index from "../index/en.js"
import login from "../login/en.js"
import projectList from "../projectList/en.js"
import post from "../post/en.js"
import admin from "../admin/en.js"

export default {
  index,
  login,
  projectList,
  post,
  admin
}



// WEBPACK FOOTER //
// ./src/locale/lang/en.js